import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class DagiRecentlyViewedStrip extends HTMLElement {
  async connectedCallback() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const currentProductId = this.dataset.currentProductId;
    let productIds = RecentlyViewed.getProducts();

    if (currentProductId) {
      productIds = productIds.filter((id) => id !== currentProductId);
    }

    const section = this.closest('.dagi-recently-viewed-section');
    const content = this.querySelector('[data-recently-viewed-content]');

    if (productIds.length === 0 || !content) {
      section?.remove();
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const sectionHTML = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const fetchedContent = parsed.querySelector('[data-recently-viewed-content]');

      if (!fetchedContent || fetchedContent.innerHTML.trim() === '') {
        section?.remove();
        return;
      }

      content.innerHTML = fetchedContent.innerHTML;
      section?.classList.remove('dagi-recently-viewed-section--pending');
    } catch {
      section?.remove();
    }
  }
}

if (!customElements.get('dagi-recently-viewed-strip')) {
  customElements.define('dagi-recently-viewed-strip', DagiRecentlyViewedStrip);
}
